/*
 Copyright (c) 2022 Skyflow, Inc.
*/
abstract class SkyflowElement {}

export default SkyflowElement;
